module.exports = __webpack_public_path__ + "img/SC.ab20ca36.png";